export default __webpack_public_path__ + "static/gamestop-377f7235d1340166c925421c818636b2.svg";